var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from 'react';
import t from 'prop-types';
import Entrada from './entrada';

var TituloContenedorUnidades = function TituloContenedorUnidades(_ref) {
  var titulo = _ref.titulo;

  if (!titulo) {
    return null;
  }

  return React.createElement('div', {
    className: 'tituloContenedorUnidades',
    dangerouslySetInnerHTML: {
      __html: titulo
    }
  });
};

TituloContenedorUnidades.propTypes = process.env.NODE_ENV !== "production" ? {
  titulo: t.string
} : {};

var ContenedorUnidadesIndice = function (_React$Component) {
  _inherits(ContenedorUnidadesIndice, _React$Component);

  function ContenedorUnidadesIndice() {
    _classCallCheck(this, ContenedorUnidadesIndice);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  ContenedorUnidadesIndice.prototype.renderUnidades = function renderUnidades() {
    var _props = this.props,
        unidades = _props.unidades,
        indexUnidad = _props.indexUnidad,
        onEntrada = _props.onEntrada;
    return unidades.map(function (unidad, index) {
      if (typeof unidad.numUnidad !== 'undefined') {
        unidad.clase = 'unidad';
      }

      return React.createElement(Entrada, _extends({
        key: 'unidad-index-' + index
      }, unidad, {
        seleccionada: indexUnidad === index,
        onClick: function onClick() {
          return onEntrada(unidad, index);
        }
      }));
    });
  };

  ContenedorUnidadesIndice.prototype.render = function render() {
    var titulo = this.props.titulo;
    return React.createElement('div', {
      className: 'contenedorUnidadesIndice'
    }, React.createElement(TituloContenedorUnidades, {
      titulo: titulo
    }), this.renderUnidades());
  };

  return ContenedorUnidadesIndice;
}(React.Component);

ContenedorUnidadesIndice.propTypes = process.env.NODE_ENV !== "production" ? {
  titulo: t.string,
  unidades: t.array.isRequired,
  indexUnidad: t.number,
  onEntrada: t.func.isRequired
} : {};
export default ContenedorUnidadesIndice;